import { DateTimeFormatStrings } from "@shared/enums";
import { DropDownItem } from "@shared/classes/general";

export class Utilities {
  static trimLeadingZero = (input: string) => input?.replace(/^0+/, '');

  static groupBy = (array: any, key: any) => {
    return array.reduce((result: any, currentValue: any) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      return result;
    }, {});
  };

  static isValidDate = (date: Date) => {
    return date && date instanceof Date && !isNaN(date.getTime());
  }

  static isEmptyString = (data: string) => data === "" || data === null || data === undefined;

  static padTo2Digits = (num: number) => {
    return num.toString().padStart(2, '0');
  }

  static formatDate = (date: Date, format: string = ""): string => {
    //Make sure the [date] passed in is truly a javascript Date object
    //Because all the follow up logics are based on this assumption.
    //Use new Date() to convert potential Moment Date object into javascript Date object.
    date = new Date(date);
    switch (format) {
      case DateTimeFormatStrings.FORMAT_1:
        return [
          date.getFullYear(),
          this.padTo2Digits(date.getMonth() + 1),
          this.padTo2Digits(date.getDate()),
        ].join('-');
      case DateTimeFormatStrings.FORMAT_2:
        return [
          this.padTo2Digits(date.getMonth() + 1),
          date.getFullYear()
        ].join('-');
      case DateTimeFormatStrings.FORMAT_3:
        return date.toLocaleDateString('en-GB').replace(/\//g, '.');
      case DateTimeFormatStrings.FORMAT_4:
        return date.toLocaleDateString('en-GB');
      case DateTimeFormatStrings.FORMAT_5:
        return date.getFullYear() + this.padTo2Digits(date.getMonth() + 1);
      case DateTimeFormatStrings.FORMAT_6:
        return `${date.getFullYear()}-${this.padTo2Digits(date.getMonth() + 1)}-${this.padTo2Digits(date.getDate())}`;
      case DateTimeFormatStrings.FORMAT_7:
        return `${date.getFullYear()}${this.padTo2Digits(date.getMonth() + 1)}${this.padTo2Digits(date.getDate())}`;
      case DateTimeFormatStrings.FORMAT_8:
        return `${this.padTo2Digits(date.getHours())}:${this.padTo2Digits(date.getMinutes())}:${this.padTo2Digits(date.getSeconds())}`;
      case DateTimeFormatStrings.FORMAT_9:
        return `${this.formatDate(date, DateTimeFormatStrings.FORMAT_1)} ${this.formatDate(date, DateTimeFormatStrings.FORMAT_8)}${Utilities.getTimeZone()}`;
      case DateTimeFormatStrings.FORMAT_10:
        return `${this.formatDate(date, DateTimeFormatStrings.FORMAT_1)}T00:00:00Z`;
      case DateTimeFormatStrings.FORMAT_11:
        return `${this.formatDate(date, DateTimeFormatStrings.FORMAT_1)}T${this.formatDate(date, DateTimeFormatStrings.FORMAT_8)}Z`;
      case DateTimeFormatStrings.FORMAT_12:
        return `${this.formatDate(date, DateTimeFormatStrings.FORMAT_1)} ${this.formatDate(date, DateTimeFormatStrings.FORMAT_8)}`;
      default:
        return date.toLocaleDateString();
    }
  }

  static getQueryStringValueFromInput = (inputData: string | string[]) => {
    if (typeof (inputData) === 'string') {
      return inputData;
    }

    return inputData.join('|');
  }

  static getLastMonthByNumber = (last: number) => {
    var currentDate = new Date();
    currentDate.setDate(1);
    var lastMonthDate = new Date();
    lastMonthDate.setDate(1);
    lastMonthDate.setMonth(lastMonthDate.getMonth() - (last - 1));
    return [this.formatDate(lastMonthDate, DateTimeFormatStrings.FORMAT_1), this.formatDate(currentDate, DateTimeFormatStrings.FORMAT_1)];
  }

  static getTimeZone = () => {
    const timezoneOffset = new Date().getTimezoneOffset()
    const offset = Math.abs(timezoneOffset)
    const offsetOperator = timezoneOffset < 0 ? '+' : '-'
    const offsetHours = Math.floor(offset / 60).toString().padStart(2, '0')
    const offsetMinutes = Math.floor(offset % 60).toString().padStart(2, '0')

    return `${offsetOperator}${offsetHours}:${offsetMinutes}`
  }

  // static base64FileDownload = (base64String: string, fileName: string) => {
  //   var decodedData = atob(base64String);
  //   const byteCharacters = atob(decodedData);
  //   const byteArrays = [];

  //   for (let offset = 0; offset < byteCharacters.length; offset += 512) {
  //     const slice = byteCharacters.slice(offset, offset + 512);
  //     const byteNumbers = new Array(slice.length);
  //     for (let i = 0; i < slice.length; i++) {
  //       byteNumbers[i] = slice.charCodeAt(i);
  //     }
  //     const byteArray = new Uint8Array(byteNumbers);
  //     byteArrays.push(byteArray);
  //   }

  //   const blob = new Blob(byteArrays);
  //   const url = window.URL.createObjectURL(blob);
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.download = fileName;
  //   link.click();
  //   window.URL.revokeObjectURL(url);
  // }

  static BinaryFileDownload = (res: any, fileName: string) => {
    if (res === undefined) {
      return;
    }

    const a = document.createElement('a');
    document.body.appendChild(a);
    const blob: any = new Blob([res], { type: 'application/binary' });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  static Sum = (sumArray: number[]) => {
    if (!sumArray || sumArray.length === 0) {
      return 0;
    }

    return sumArray.reduce((x, y) => x + y, 0);
  }

  static PatchEmptyDropDownItem(dropDownList: DropDownItem[]) {
    var emptyDropDownItem = { label: "", value: "" } as DropDownItem;
    if (!dropDownList) {
      return [emptyDropDownItem];
    }

    return [emptyDropDownItem, ...dropDownList];
  }
}
